import axios from '@_system/axios/axios.js'
export default {
	path: '/collection',
	list(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	updatefield(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/updatefield/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	
	
	
	getInvoice (data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/getInvoice', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	getDetail (id,data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path + '/getDetail/'+id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	updateCollectionOrder(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/updatecollectionorder/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},	
	listTrades(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/listTrades/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	listTradesnew(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/listTradesnew', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	joinorder(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/joinorder/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
		
	
	getReceivedpayment(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/receivedpayment/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},	
	import(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/import', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	importtemplate(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/importtemplate', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	export (data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/export', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	sendjindie (data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/sendjindie', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	sendjindieDetail (data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/sendjindieDetail', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	syninvoice (data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/syninvoice', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},


	init(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get('moduleConfig/admin/collection.collection', data, (res) => {
				resolve(res.data)
			},reject,true)
		})
	}
}
